"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Authentication_module_1 = tslib_1.__importDefault(require("./modules/Authentication.module"));
const Product_module_1 = tslib_1.__importDefault(require("./modules/Product.module"));
const loadProductReviewLandingModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData), (0, Authentication_module_1.default)()],
});
exports.default = loadProductReviewLandingModule;
